"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("../../../theme"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Alert = function Alert() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel20,
    d: "M21.693 39.984c-2.972.174-5.689-1.124-8.362-2.784-2.343-1.455-4.96-3.053-6.812-5.403-1.722-2.183-3.288-4.685-4.383-7.241a27.633 27.633 0 0 1-2.051-8.03c-.289-2.917.166-5.775 1.246-8.12 1.598-3.473 4.925-5.764 8.576-7.134C13.709-.155 17.983-.204 21.577.266c2.399.314 5.151.925 7.822 2.25 2.331 1.158 4.98 2.354 6.794 4.378 1.644 1.836 2.648 4.268 3.336 6.887.723 2.749.543 5.6-.062 8.384-.603 2.773-1.852 5.384-3.415 7.796a24.275 24.275 0 0 1-6.026 6.359c-2.65 1.944-5.403 3.494-8.333 3.664Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: _theme["default"].scaleLevel100,
    fillRule: "evenodd",
    d: "M20 28.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm0 1.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Zm1.25-6.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM20 14.167a.833.833 0 0 0-.833.833v5a.833.833 0 0 0 1.666 0v-5a.833.833 0 0 0-.833-.833Z"
  }));
};
var _default = exports["default"] = Alert;